/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketShoppingBagIcon16Light } from './MarketShoppingBagIcon16Light';
import { MarketShoppingBagIcon16Regular } from './MarketShoppingBagIcon16Regular';
import { MarketShoppingBagIcon16Solid } from './MarketShoppingBagIcon16Solid';
import { MarketShoppingBagIcon20Light } from './MarketShoppingBagIcon20Light';
import { MarketShoppingBagIcon20Regular } from './MarketShoppingBagIcon20Regular';
import { MarketShoppingBagIcon20Solid } from './MarketShoppingBagIcon20Solid';
import { MarketShoppingBagIcon24Regular } from './MarketShoppingBagIcon24Regular';
import { MarketShoppingBagIcon24Solid } from './MarketShoppingBagIcon24Solid';
import { MarketShoppingBagIcon32Regular } from './MarketShoppingBagIcon32Regular';
import { MarketShoppingBagIcon64Regular } from './MarketShoppingBagIcon64Regular';
var sizes = {
    16: {
        light: MarketShoppingBagIcon16Light,
        regular: MarketShoppingBagIcon16Regular,
        solid: MarketShoppingBagIcon16Solid,
    },
    20: {
        light: MarketShoppingBagIcon20Light,
        regular: MarketShoppingBagIcon20Regular,
        solid: MarketShoppingBagIcon20Solid,
    },
    24: {
        regular: MarketShoppingBagIcon24Regular,
        solid: MarketShoppingBagIcon24Solid,
    },
    32: {
        regular: MarketShoppingBagIcon32Regular,
    },
    64: {
        regular: MarketShoppingBagIcon64Regular,
    },
};
export var MarketShoppingBagIcon = forwardRef('MarketShoppingBagIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
